// Pasos del recorrido de compra que mide el backend (checkout_event). Lista
// cerrada: tiene que coincidir con CHECKOUT_STEPS de accesso-be
// (src/checkout_event/types.ts), que rechaza cualquier otro.
export type CheckoutStep =
  | 'event_view'
  | 'tickets_open'
  | 'tickets_continue'
  | 'seats_open'
  | 'seats_continue'
  | 'sold_out_shown'
  | 'data_view'
  | 'data_submit'
  | 'data_error'
  | 'payment_view'
  | 'payment_method_selected'
  | 'payment_submit'
  | 'payment_error'
  | 'payment_redirect'
  | 'inapp_notice_shown'
  | 'result_approved'
  | 'result_pending'
  | 'result_rejected'
  | 'result_not_found'
  | 'reservation_warning'
  | 'reservation_expired'
  | 'resume_shown'
  | 'resume_accepted';

export type CheckoutStepProperties = Record<string, string | number | boolean | null>;

export interface CheckoutEventInputDTO {
  step: CheckoutStep;
  order_id?: string | null;
  properties?: CheckoutStepProperties | null;
}

export interface CreateCheckoutEventsDTO {
  session_id: string;
  checkout_version: 1 | 2;
  events: CheckoutEventInputDTO[];
}

// Lo que viaja con la orden para medir de dónde vino la compra.
export interface CheckoutContextDTO {
  version: 1 | 2;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  fbclid?: string;
  gclid?: string;
  terms_version: string;
}

// Qué checkout ve el comprador. Hasta que el checkout nuevo salga detrás del
// flag checkout_v2 (etapa 4 del PRD), todos ven el actual.
export const CURRENT_CHECKOUT_VERSION: 1 | 2 = 1;

// Versión de los términos para compradores (public/buyer-terms.md): la fecha
// del último cambio. Se actualiza en el mismo PR que cambie ese archivo.
export const BUYER_TERMS_VERSION = '2026-10-03';
